import NativeHorizontalVideo from "./NativeHorizontalVideo";
import NativeVerticalVideo from "./NativeVerticalVideo";
import React from "react";

const noop = () => {};

export default function Video({
  image,
  glance,
  index,
  onPlay = noop,
  onPause = noop
}) {
  if (glance.type === "WALLPAPER") {
    return null;
  }
  if (!(glance.peek.type === "NATIVE_VIDEO")) {
    return null;
  }
  const overflow = glance.peek.nativeVideoPeek.overflow;
  return overflow ? (
    <NativeVerticalVideo
      image={image}
      glance={glance}
      onPlay={onPlay}
      onPause={onPause}
      index={index}
    />
  ) : (
    <NativeHorizontalVideo
      glance={glance}
      onPlay={onPlay}
      onPause={onPause}
      index={index}
    />
  );
}
